import { RouteRecordRaw, RouterView, RouteLocationNormalized } from "vue-router";
import { h } from "vue";

const configurationRoutes: RouteRecordRaw = {
  path: "/configuration",
  component: () => import("../layouts/SimpleLayout.vue"),
  children: [
    {
      path: "",
      name: "configuration",
      component: () => import("../views/ConfigurationViewV2.vue"),
      meta: { breadcrumb: "configuration" },
      children: [
        {
          path: ":config",
          component: { render: () => h(RouterView) },
          redirect: (to) => ({ name: "selectedConfig", params: to.params }),
          meta: {
            breadcrumb: (route: RouteLocationNormalized) => decodeURIComponent(route.params.config as string),
          },
          children: [
            {
              path: "",
              name: "selectedConfig",
              component: () => import("../views/SelectedConfigView.vue"),
            },
            {
              path: ":uuid",
              name: "editConfig",
              component: () => import("../views/ConfigFormView.vue"),
              props: true,
              meta: { breadcrumb: "edit" },
            },
            {
              path: "new",
              name: "createConfig",
              component: () => import("../views/ConfigFormView.vue"),
              props: true,
              meta: { breadcrumb: "new" },
            },
          ],
        },
      ],
    },
  ],
};

export default configurationRoutes;
